import { render, staticRenderFns } from "./SocialLearningOverflowMenu.vue?vue&type=template&id=300d37af&scoped=true&"
import script from "./SocialLearningOverflowMenu.vue?vue&type=script&lang=js&"
export * from "./SocialLearningOverflowMenu.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningOverflowMenu.vue?vue&type=style&index=0&id=300d37af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d37af",
  null
  
)

export default component.exports